import React from 'react';
import './Footer.css';
// import { SmoothScrollLink } from "organism-react-scroll-nav";

function Footer() {
  return (
    <div className="footer jumbotron-fluid">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 mx-auto">
            <img src={process.env.PUBLIC_URL + "/logo.svg"} className="img-fluid" alt="logo" />
            <p>Jl. Raya Dongkal, RT.001/RW.006, Cipondoh Makmur, Kec. Cipondoh, Kota Tangerang, Banten 15148</p>
            <span>Phone: +6285161016522</span> <br></br>
            <span>Email: code@faisalhakim.com</span>
          </div>
          <div className="col-lg-3 mx-auto my-auto">
            <h4>Useful Links</h4>
            <ul className="text-left">
              <li>
                <i className="fa fa-chevron-right" aria-hidden="true"></i> <a href="#Home">Beranda</a>
              </li>
              <li>
                <i className="fa fa-chevron-right" aria-hidden="true"></i> <a href="#Destination">Destinasi</a>
              </li>
              <li>
                <i className="fa fa-chevron-right" aria-hidden="true"></i> <a href="#Galery">Galeri</a>
              </li>
              <li>
                <i className="fa fa-chevron-right" aria-hidden="true"></i> <a href="#Travel">Travel</a>
              </li>
              <li>
                <i className="fa fa-chevron-right" aria-hidden="true"></i> <a href="#Footer">Kontak Kami</a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 mx-auto my-auto">
            <h4>Travels</h4>
            <ul className="text-left">
              <li>
                <a href="https://jelajahgarut.com/">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Jelajah Garut
                </a>
              </li>
              <li>
                <a href="https://digarut.com/">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Di Garut
                </a>
              </li>
              <li>
                <a href="https://www.doyanjalan.com/">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Doyan Jalan
                </a>
              </li>
              <li>
                <a href="https://pesonaindo.com/">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Pesona Indo
                </a>
              </li>
              <li>
                <a href="https://sanjayatour.com/">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Sanjaya Tour
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 mx-auto my-auto">
            <h4>Our Social Networks</h4>
            <ul className="text-left">
              <li className="notReady" data-toggle="tooltip" data-placement="top" title="Mohon maaf, belum tersedia">
                <i className="fa fa-facebook-square" aria-hidden="true"></i>
                &emsp;Facebook
              </li>
              <li className="notReady" data-toggle="tooltip" data-placement="top" title="Mohon maaf, belum tersedia">
                <i className="fa fa-linkedin-square" aria-hidden="true"></i>
                &emsp;LinkedIn
              </li>
              <li className="notReady" data-toggle="tooltip" data-placement="top" title="Mohon maaf, belum tersedia">
                <i className="fa fa-twitter-square" aria-hidden="true"></i>
                &emsp;Twitter
              </li>
              <li className="notReady" data-toggle="tooltip" data-placement="top" title="Mohon maaf, belum tersedia">
                <i className="fa fa-instagram" aria-hidden="true"></i>
                &emsp;Instagram
              </li>
              <li className="notReady" data-toggle="tooltip" data-placement="top" title="Mohon maaf, belum tersedia">
                <i className="fa fa-whatsapp" aria-hidden="true"></i>
                &emsp;Whatsapp
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p className="copyright text-center">© 2020 WeSpace | All Right Reversed</p>
    </div>
  );
}

export default Footer;
